import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import "@WhiteCap/Common/SetCookieDomainDefaults";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
// EWC-5504 | Added OrderDetails widgets to the main bundle for SSR page printing.
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn|OrderDetails)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

const service = require.context("./Services", true);
service.keys().forEach(key => service(key));

const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

// D:\Projects\Opti Project\whitecap-ecw\src\FrontEnd\modules\blueprints\WhiteCap\wwwRoot\staticContent\styleSheet.css

setPostStyleGuideTheme({
    typography: {
        fontFamilyImportUrl: "",
        body: {
            fontFamily: "Gotham A,Gotham B",
        },
        h1: {
            weight: 400,
            size: "32px",
            lineHeight: "1.5rem",
        },
        h2: {
            weight: 400,
            size: "18px",
            lineHeight: "1.5rem",
        },
        h3: {
            weight: 400,
            size: "20px",
            lineHeight: "1.5rem",
        },
        h4: {
            weight: 700,
            size: "24px",
            lineHeight: "1.5rem",
        },
        h5: {
            weight: 500,
            size: "16px",
            lineHeight: "1.5rem",
        },
        h6: {
            weight: 700,
            size: "16px",
            lineHeight: "1.5rem",
        },
    },
    dataTable: {
        defaultProps: {
            css: css`
            tr:nth-child(odd){
                background: ${getColor("common.accent")} !important;
                
            }
            tr:nth-child(even){
                background: #FFF;  
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
   background: ${getColor("common.accent")} !important;
                `,
                        css`
                background: ${getColor("common.accent")} !important;
                `,
                        css``,
                        css``,
                        css``,
                    ])}
            }
            td{
                height:65px;
                vertical-align: middle;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                    height: 50px;
                    vertical-align: middle;

                `,
                        css`
                height: 50px;
                vertical-align: middle;

                `,
                        css``,
                        css``,
                        css``,
                    ])}
            }
            `,
        }
    },
    button: {
        primary: {
            typographyProps: {
                css: css`
                  ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                            font-size: 12px;
                            `,
                            css`
                            font-size: 12px;
                            `,
                            css``,
                            css``,
                            css``,
                        ])}
                `
            },
        },
        secondary: {
            typographyProps: {
                css: css`
                 ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                            font-size: 12px;
                            `,
                            css`
                            font-size: 12px;
                            `,
                            css``,
                            css``,
                            css``,
                        ])}
                `
            },
        },
        tertiary: {
            typographyProps: {
                css: css`
                 ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                            font-size: 12px;
                            `,
                            css`
                            font-size: 12px;
                            `,
                            css``,
                            css``,
                            css``,
                        ])}
                `
            },
        },
    }
});
